/* Copyright (c) 2022 Xperi. All Rights Reserved.  */

import React, { FunctionComponent } from 'react';
import PropTypes from 'prop-types';
import { BrnadingIconProps } from './BrandingIconProps';
import { ImageLoader } from '../../../../ImageLoader';
import { ImageLoaderTypes } from '../../../../ImageLoader/ImageLoaderTypes';

const BrandingIcon: FunctionComponent<BrnadingIconProps> = (props): JSX.Element => {
    const { iconURL } = props;
    return (
        <React.Fragment>
            {iconURL ? (
                <ImageLoader src={iconURL} imageType={ImageLoaderTypes.OVERLAY_BRANDING_ICON} />
            ) : null}
        </React.Fragment>
    );
};

BrandingIcon.propTypes = {
    iconURL: PropTypes.string,
};
export default BrandingIcon;
